/**
 * Which instances of which layers reference each row of the loaded LOD, in the
 * row order of splat-transform's LOD stream. An LCC2 export copies these
 * references to every anchored splat of the other LODs: none = deleted,
 * several = duplicated or separated into further layers.
 */
interface LayerInstances {
    readonly count: number;
    readonly sourceRow: Uint32Array;
}

class EditState {
    readonly offsets: Uint32Array;
    readonly layer: Uint16Array;
    readonly instance: Uint32Array;

    private constructor(offsets: Uint32Array, layer: Uint16Array, instance: Uint32Array) {
        this.offsets = offsets;
        this.layer = layer;
        this.instance = instance;
    }

    static build(numRows: number, layers: LayerInstances[], rowToStream: Uint32Array | null) {
        const streamRow = (row: number) => {
            const r = rowToStream ? rowToStream[row] : row;
            if (r === undefined || r >= numRows) throw new Error(`Row ${row} is outside the loaded LOD`);
            return r;
        };

        const offsets = new Uint32Array(numRows + 1);
        for (const layer of layers) {
            for (let i = 0; i < layer.count; ++i) offsets[streamRow(layer.sourceRow[i]) + 1]++;
        }
        for (let r = 0; r < numRows; ++r) offsets[r + 1] += offsets[r];

        const total = offsets[numRows];
        const layerOut = new Uint16Array(total);
        const instanceOut = new Uint32Array(total);
        const cursor = offsets.slice(0, numRows);
        layers.forEach((layer, l) => {
            for (let i = 0; i < layer.count; ++i) {
                const slot = cursor[streamRow(layer.sourceRow[i])]++;
                layerOut[slot] = l;
                instanceOut[slot] = i;
            }
        });

        return new EditState(offsets, layerOut, instanceOut);
    }
}

export { EditState, type LayerInstances };
